import { I_blockLatest } from '@/api/blockChain/type'
import { createGlobalStore } from 'hox'
import { useState } from 'react'

function useBlock() {
  const [blockLatest, setBlockLatest] = useState<I_blockLatest>()
  const [averageHeightTime, setAverageHeightTime] = useState<number>(5)

  return { blockLatest, setBlockLatest, averageHeightTime, setAverageHeightTime }
}

export const [useBlockStore, getBlockStore] = createGlobalStore(useBlock)
